package de.ohhhmhhh.frontend.admin.mvvm

import androidx.compose.runtime.mutableStateOf
import kotlinx.coroutines.*
import kotlin.coroutines.EmptyCoroutineContext

open class BaseViewModel<State>(initial: State) {
    private val scope = CoroutineScope(EmptyCoroutineContext + SupervisorJob())

    var state = mutableStateOf(initial)
        private set

    fun value() = state.value

    fun update(block: State.() -> State) {
        state.value = state.value.block()
    }

    fun launch(block: suspend () -> Unit) {
        scope.launch { block() }
    }

    @OptIn(DelicateCoroutinesApi::class)
    fun launchBackground(block: suspend () -> Unit) {
        GlobalScope.launch { block() }
    }
}